import axios from "axios";
import { useState } from "react";

export default function GetAddressInfo() {
  const [addressData, setAddressData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const getAddress = async (postcode) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `https://api.getAddress.io/find/${postcode}?api-key=90BzkoVB-UGZQBECvAil-A36743&expand=true`
      );
      setAddressData(response.data);
      setError(null);
    } catch (err) {
    //  alert("No address found, please try again");
      setAddressData(null);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return { addressData, error, loading, getAddress };
}
